import { render, staticRenderFns } from "./ProductMediaList.vue?vue&type=template&id=1393d067&"
import script from "./ProductMediaList.vue?vue&type=script&lang=js&"
export * from "./ProductMediaList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports